import { guestAnalyticsKeys } from "src/data/guestAnalytics/guestAnalyticsQueryCache"
import {
  TFetchGuestMessagesAggregatedAnalyticsQueryParams,
  TFetchGuestMessagesCountAnalyticsQueryParams,
} from "src/data/guestAnalytics/guestAnalyticsTypes"
import { useMinutQuery } from "src/hooks/minutQuery"

export function useFetchGuestMessagesCountAnalytics({
  orgId,
  filters,
}: {
  orgId: string
  filters: TFetchGuestMessagesCountAnalyticsQueryParams
}) {
  return useMinutQuery<"/organizations/{organization_id}/analytics/guest_messages_count">(
    {
      queryKey: guestAnalyticsKeys.guestMessagesCount({ orgId, filters }),
      queryPath: `/organizations/${orgId}/analytics/guest_messages_count`,
      filters,
    }
  )
}

// ts-prune-ignore-next
export function useFetchGuestMessagesAggregatedAnalytics({
  orgId,
  filters,
}: {
  orgId: string
  filters: TFetchGuestMessagesAggregatedAnalyticsQueryParams
}) {
  return useMinutQuery<"/organizations/{organization_id}/analytics/aggregated_group/guest_messages">(
    {
      queryKey: guestAnalyticsKeys.guestMessagesAggregated({ orgId, filters }),
      queryPath: `/organizations/${orgId}/analytics/aggregated_group/guest_messages`,
      filters,
    }
  )
}
